import React from 'react';

import { talentIcon } from '@atlaskit/logo/raw-icons';

/** Decorative product icon accompanying the localized Talent attribution name. */
export const TalentAttributionIcon = (): React.JSX.Element => (
	<img src={talentIcon} alt="" width={16} height={16} />
);
